import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../hooks/useAuth';
import { extractErrorMessage } from '../../utils/helpers';

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';

const PasswordChangeModal = ({ isOpen, onClose, onSuccess }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { changePassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (newPassword !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }
    
    if (newPassword.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    
    setIsLoading(true);
    
    const result = await changePassword(oldPassword, newPassword);
    
    if (result.success) {
      onSuccess();
      onClose();
    } else {
      setError(result.error);
    }
    
    setIsLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" style={{backgroundColor: 'rgba(0, 0, 0, 0.8)'}}>
      <div className="rounded-lg p-6 w-full max-w-md shadow-2xl" style={{backgroundColor: '#2C3148'}}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold" style={{color: '#FFFFFF'}}>Changer le mot de passe</h2>
          <button 
            onClick={onClose} 
            className="transition-colors duration-200"
            style={{color: '#8A92B2'}}
            onMouseEnter={(e) => e.currentTarget.style.color = '#FF5757'}
            onMouseLeave={(e) => e.currentTarget.style.color = '#8A92B2'}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1" style={{color: '#FFFFFF'}}>
              Ancien mot de passe
            </label>
            <input
              type="password"
              required
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
              style={{
                backgroundColor: '#242A3D',
                borderColor: '#4A5BFF',
                color: '#FFFFFF'
              }}
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1" style={{color: '#FFFFFF'}}>
              Nouveau mot de passe
            </label>
            <input
              type="password"
              required
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
              style={{
                backgroundColor: '#242A3D',
                borderColor: '#4A5BFF',
                color: '#FFFFFF'
              }}
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1" style={{color: '#FFFFFF'}}>
              Confirmer le nouveau mot de passe
            </label>
            <input
              type="password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
              style={{
                backgroundColor: '#242A3D',
                borderColor: '#4A5BFF',
                color: '#FFFFFF'
              }}
            />
          </div>

          {error && (
            <div className="text-sm p-3 rounded-md" style={{
              color: '#FF5757',
              backgroundColor: 'rgba(255, 87, 87, 0.1)',
              border: '1px solid #FF5757'
            }}>
              {error}
            </div>
          )}

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-md transition-colors duration-200"
              style={{
                color: '#8A92B2',
                borderColor: '#1C2133'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1C2133';
                e.currentTarget.style.color = '#FFFFFF';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#8A92B2';
              }}
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-4 py-2 rounded-md transition-all duration-300 disabled:opacity-50"
              style={{
                background: 'linear-gradient(135deg, #4A5BFF 0%, #7A5FFF 100%)',
                color: '#FFFFFF'
              }}
              onMouseEnter={(e) => {
                if (!isLoading) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(74, 91, 255, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '';
              }}
            >
              {isLoading ? 'Modification...' : 'Modifier'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordChangeModal;
